import React from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import pluralize from 'pluralize'
import PropTypes from 'prop-types'
import { InitiativeDiscussionIcon, ViewGlyph12Icon } from 'assets/icons'
import InitiativeDefaultThumbnail from 'src/sites/kits/Initiative/components/DefaultThumbnail'
import ObjectPrivacyBadge from 'src/sites/kits/Object/components/PrivacyBadge'

const InitiativeListItemRow = ({
   archived,
   borderStyle,
   coverUrl,
   disabled,
   dateLastUpdated,
   iconBackgroundColor,
   iconColor,
   iconName,
   linkTo,
   name,
   numThreadEntries,
   numViews,
   padding,
   pinned,
   privacy,
   showStats,
   typeSlug
}) => {
   const LinkElement = disabled
      ? 'div'
      : Link

   return (
      <View
         position="relative"
         display="flex"
         alignItems="center"
         width="100%"
         padding={padding}
         borderTop={borderStyle}
         className={css`
            &:hover {
               background-color: rgba(56, 170, 242, 0.03);
            }
         `}>
         <LinkElement to={linkTo}>
            <View
               flex="0 0 auto"
               width="30px"
               height="30px"
               borderRadius="4px"
               backgroundImage={`url(${coverUrl})`}
               backgroundSize="cover"
               backgroundPosition="center center"
               marginRight="20px"
               style={{ overflow: 'hidden' }}>
               {!coverUrl && (
                  <InitiativeDefaultThumbnail
                     highlightColor={iconBackgroundColor}
                     iconColor={iconColor}
                     iconName={iconName}
                  />
               )}
            </View>
         </LinkElement>
         <View
            display="flex"
            flex="1 1 auto"
            maxWidth="calc(100% - 50px)"
            flexFlow="column[a-b] row[c-f]"
            opacity={archived && '0.5'}>
            <View flex="1 1 auto">
               <View width="100%">
                  <LinkElement to={linkTo}>
                     <Text
                        size="2"
                        weight="medium"
                        color="#222"
                        style={{
                           overflow: 'hidden',
                           textOverflow: 'ellipsis',
                           wordBreak: 'break-word'
                        }}>
                        {name}
                     </Text>
                  </LinkElement>
                  {archived && (
                     <View
                        display="inline-flex"
                        alignItems="center"
                        height="15px"
                        border="1px solid #ddd"
                        padding="0px 5px"
                        borderRadius="3px"
                        marginLeft="10px">
                        <Text size="0.7" weight="bold" transform="uppercase" color="#777">
                           Archived
                        </Text>
                     </View>
                  )}
                  <ObjectPrivacyBadge privacy={privacy} />
                  <div className="ui-meta-text">
                     {`Last updated ${dateLastUpdated}`}
                  </div>
               </View>
            </View>
            <View
               display={showStats ? 'flex' : 'none'}
               alignItems="center"
               flex="0 0 auto"
               paddingLeft="60px[c-f]"
               paddingRight="15px">
               {numThreadEntries > 0 && (
                  <View display="flex" alignItems="center" marginRight="15px">
                     <View marginRight="5px">
                        <InitiativeDiscussionIcon
                           width="12px"
                           height="12px"
                           color="#aaa"
                        />
                     </View>
                     <Text size="1" color="#aaa">
                        {`${pluralize('Comments', numThreadEntries, true)} `}
                     </Text>
                  </View>
               )}
               {numViews > 0 && (
                  <>
                     <View margin="0px 5px 0px 0px">
                        <ViewGlyph12Icon
                           width="12px"
                           height="12px"
                           color="#aaa"
                        />
                     </View>
                     <Text size="1" color="#aaa">
                        {pluralize('Views', numViews, true)}
                     </Text>
                  </>
               )}
            </View>
         </View>
      </View>
   )
}

InitiativeListItemRow.propTypes = {
   archived: PropTypes.bool,
   borderStyle: PropTypes.string,
   coverUrl: PropTypes.string,
   disabled: PropTypes.bool,
   dateLastUpdated: PropTypes.string.isRequired,
   iconBackgroundColor: PropTypes.string,
   iconColor: PropTypes.string,
   iconName: PropTypes.string,
   linkTo: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   numThreadEntries: PropTypes.number.isRequired,
   numViews: PropTypes.number.isRequired,
   padding: PropTypes.string,
   pinned: PropTypes.bool,
   privacy: PropTypes.string.isRequired,
   showStats: PropTypes.bool,
   typeSlug: PropTypes.string.isRequired
}

InitiativeListItemRow.defaultProps = {
   archived: false,
   borderStyle: '1px solid rgba(0,0,0,0.075)',
   coverUrl: undefined,
   disabled: false,
   iconBackgroundColor: undefined,
   iconColor: '#ccc',
   iconName: undefined,
   padding: '20px 10px',
   pinned: false,
   showStats: true
}

export default InitiativeListItemRow
